export { default } from './EnergiaSolarBanner';
